import {
  HomePageCompanyLogo,
  HomePageRecentlyVisited,
  HomePageStarredEntities,
} from '@backstage/plugin-home';
import { Content, InfoCard, Page } from '@backstage/core-components';


import { HomePageSearchBar } from '@backstage/plugin-search';
import {

  SearchContextProvider,
} from '@backstage/plugin-search-react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import Logo from './logo';
import CatalogFeaturedCards from '../catalogFeaturedCards/CatalogFeaturedCards';
import GettingStarted from '../gettingStarted/GettingStarted';


export default {
  title: 'Plugins/Home/Templates',
};

const useStyles = makeStyles(theme => ({
  searchBarInput: {
    maxWidth: '60vw',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '50px',
    boxShadow: theme.shadows[1],
  },
  searchBarOutline: {
    borderStyle: 'none'
  }
}));

const useLogoStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(5, 0),
  },
  svg: {
    width: 'auto',
    height: 100,
  },
  path: {
    fill: '#7df3e1',
  },
}));

export const DefaultTemplate = () => {
  const classes = useStyles();
  const { container } = useLogoStyles();

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={6}>
            <HomePageCompanyLogo
              className={container}
              logo={<Logo />}
            />
            <Grid container item xs={12} justifyContent='center'>
            <Typography variant="h2">Welcome to Speedyfreight developer portal</Typography>
              <HomePageSearchBar
                InputProps={{ classes: { root: classes.searchBarInput, notchedOutline: classes.searchBarOutline }}}
                placeholder="Search"
              />
            </Grid>
              <Typography
              variant="h3"
              style={{ marginBottom: '15px', textAlign: 'center' }}
              >
                  For You
              </Typography>
              <Grid container item xs={12} justifyContent='center' spacing={3}>
                <Grid item xs={12} md={4}>
                  <InfoCard title="Featured Items" variant="gridItem">
                    <CatalogFeaturedCards />
                  </InfoCard>
                </Grid>
                <Grid item xs={12} md={4}>
                  <HomePageRecentlyVisited />
                </Grid>
                <Grid item xs={12} md={4}>
                  <HomePageStarredEntities />
                </Grid>
              </Grid>
              <Typography
              variant="h3"
              style={{ marginBottom: '15px', textAlign: 'center' }}
              >
                  Getting Started
              </Typography>
            <Grid container item xs={12} justifyContent='center'>
              <GettingStarted />
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};